var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPayback = function SvgPayback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 21",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.445 10.772-5.367 5.882-5.113-5.882"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M16.601 18.15v-.001.001Zm-12.083.46c3.532 2.682 8.795 2.493 12.083-.46l-2.245-2.69c-2.103 1.687-5.318 1.652-7.34-.086-2-1.62-2.626-4.572-1.43-6.83 1.743-3.412 6.527-3.93 8.813-.82.669.9.998 2.006.952 3.12h5.835c-.045-3.59-2.053-7.072-5.15-8.882C10.793-1.192 3.827.945 1.358 6.562-.546 10.723.81 15.95 4.518 18.608ZM19.59 8.654c-.709-3.883-4.372-6.833-8.326-6.598v.002l.006.312a8.205 8.205 0 0 1 3.058.62c2.428.99 4.24 3.215 4.848 5.752.121.51.194 1.028.23 1.553l.308-.002c.016-.549-.022-1.1-.124-1.64Z"
  })));
};
export default SvgPayback;